const adsExcluded = [
	'/about',
	'/advertise',
	'/changelog',
	'/install',
	'/legal',
	'/login',
	'/mydecks',
	'/passwordreset',
	'/pricing',
	'/privacy',
	'/product/collection-manager',
	'/roadmap',
	'/search',
	'/signup',
	'/support',
	'/terms',
	'/verifyemail'
]

export default adsExcluded
